export const INTEGRATION_TYPE = 'snapchat-marketing-inbound'
export const DATA_TYPE_KEY = 'data_type'

export const DATA_TYPES = [
  { type: 'adaccounts', label: 'Ad Accounts' },
  { type: 'ads', label: 'Ads' },
  { type: 'adsquads', label: 'Ad Set' },
  { type: 'campaigns', label: 'Campaigns' },
  { type: 'creatives', label: 'Creatives' },
  { type: 'media', label: 'Media' },
  { type: 'organizations', label: 'Organizations' },
  // { type: 'segments', label: 'Segments' },
] as const
